import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CustomButton from '../../../components/Button';
import { closeModal } from '../../../slices/modal.slice';
import { RootState } from '../../../store';
import { useAppDispatch } from '../../../store/hooks';
import styles from '../../ResetPassword/ResetPassword.module.scss';

const ResetPasswordModal = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLinkExpired } = useSelector((state: RootState) => state.auth);
  return (
    <div className={styles.customModalContentWrapper}>
      {isLinkExpired ? (
        <>
          <h6>Link Expired!</h6>
          <p>Please click on the button below to request for a new password.</p>
          <CustomButton
            variant='contained'
            sx={{
              marginTop: '20px',
              width: '80%',
            }}
            onClick={() => {
              navigate('/forgot-password');
              dispatch(closeModal());
            }}
          >
            Forgot Password
          </CustomButton>
        </>
      ) : (
        <>
          <h6>Password changed!</h6>
          <p>You have successfully reset your Password.</p>
          <CustomButton
            variant='contained'
            sx={{
              marginTop: '20px',
              width: '80%',
            }}
            onClick={() => {
              localStorage.removeItem('loginFormData');
              navigate('/login');
              dispatch(closeModal());
            }}
          >
            Login Now
          </CustomButton>
        </>
      )}
    </div>
  );
};

export default ResetPasswordModal;
